import { createSelector } from 'reselect';

export const selectActiveCategory = createSelector(
  (categories, categoryId) =>
    categories.get('data')
      ? categories.get('data').find(category => category.get('id') === parseInt(categoryId, 10))
      : null,
  category => (category ? category : null)
);

export const selectActiveRecord = createSelector(
  (section, videoId) =>
    section.get('data')
      ? section.getIn(['data', 'libraryRecords']).find(record => record.get('id') === parseInt(videoId, 10))
      : null,
  record => (record ? record : null)
);

export const selectActiveCategorySections = createSelector(
  selectActiveCategory,
  category => category ?
    category.get('sections').toJS() :
    []
);

export const selectActiveSection = createSelector(
  state => state.library.activeSection,
  section => (section.get('data') ? section.get('data').toJS() : null)
);



// WEBPACK FOOTER //
// ./src/library/selectors.js